var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"itemWrapper"},[_c('h1',{staticClass:"ipdetailitemvalue"},[_vm._v(_vm._s(_vm.displayValue)+"+")]),_c('p',{staticClass:"ipdetailitemname"},[_vm._v(_vm._s(_vm.item_name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }